import { BuiltinInterface } from '../../BuiltinInterface';
import { BuiltinValueObject } from '../../BuiltinValueObject';
import { PublicKeyFrom } from './from';
class PublicKeyInterface extends BuiltinInterface {
}
class PublicKeyValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'PublicKeyConstructor';
    }
}
class PublicKeyConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addContractInterface('PublicKey', new PublicKeyInterface());
    builtins.addContractValue('PublicKey', new PublicKeyValue());
    builtins.addContractInterface('PublicKeyConstructor', new PublicKeyConstructorInterface());
    builtins.addContractMember('PublicKeyConstructor', 'from', new PublicKeyFrom());
};

//# sourceMappingURL=index.js.map
